import { Stack } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { config } from "../App";

const genre = ["All", "Education", "Sports", "Movies", "Comedy", "Lifestyle"];
const contentRating = ["Anyone", "7+", "12+", "16+", "18+"];
const options = ["releaseDate", "viewCount"];

const GeneralPanel = ({
  contentRatingHandler,
  filterHandler,
  setfilter,
  select,
  rating,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selected, setSelected] = useState("Release Date");

  async function shortFilter(option) {
    try {
      console.log(option);
      const filterResponse2 = await axios.get(`${config.endpoint}/videos?sortBy=${option}`);
      setfilter(filterResponse2.data.videos);
      return filterResponse2;
    } catch (err) {
      if (err.response.status === 404) {
        console.log("Page not found");
      } else {
        console.log(err);
      }
    }
  }

  return (
    <Stack
      sx={{
        position: "sticky",
        background: " #313131",
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{ p: 2 }}
        flexWrap="wrap"
      >
        {genre.map((ele) =>
          ele === "All" ? (
            <button
              className={
                select.includes(ele) ? "genre-button-1" : "genre-button"
              }
              value={ele}
              key={ele}
              name={ele}
              onClick={(e) => filterHandler(e)}
            >
              {ele} Genre
            </button>
          ) : (
            <button
              className={
                select.includes(ele) ? "genre-button-1" : "genre-button"
              }
              value={ele}
              key={ele}
              name={ele}
              onClick={(e) => filterHandler(e)}
            >
              {ele}
            </button>
          )
        )}
        <div className="dropdown">
          <div className="dropdown-btn" onClick={(e) => setIsActive(!isActive)}>
            <SwapVertIcon />
            {selected}
          </div>
          {isActive && (
            <div className="dropdown-content">
              {options.map((option, index) => (
                <div
                  onClick={(e) => {
                    setSelected(option);
                    setIsActive(false);
                    shortFilter(option);
                  }}
                  className="dropdown-item"
                  key= {index}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </Stack>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={5}
        sx={{ p: 2 }}
        flexWrap="wrap"
      >
        {contentRating.map((ele) =>
          ele === "Anyone" ? (
            <button
              className={rating === ele ? "genre-button-1" : "genre-button"}
              value={ele}
              key={ele}
              name={ele}
              onClick={contentRatingHandler}
            >
              {ele}
            </button>
          ) : (
            <button
              className={rating === ele ? "genre-button-1" : "genre-button"}
              value={ele}
              key={ele}
              name={ele}
              onClick={contentRatingHandler}
            >
              {ele}
            </button>
          )
        )}
      </Stack>
    </Stack>
  );
};

export default GeneralPanel;
